<div khA11yAlert="status" [khA11yLabel]="'A11Y_ALERT.LOADING' | translate">
  <kh-img path="/spinner-green.gif" class="spinner-green LoadingIconWhite" khA11yHidden></kh-img>
</div>